<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                lg="8"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Edit Faq</h1>
                <v-btn to="/faq/create">
                    <v-icon
                        left
                        small
                    >
                        fas fa-plus-circle
                    </v-icon>
                    Add Faq
                </v-btn>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                lg="8"
                align="center"
                justify="center"
            >
                <FaqEditForm />
            </v-col>
        </v-row>
        <v-dialog
            v-model="deleteModal"
            width="500"
        >
            <v-card>
                <v-card-title>
                    <v-icon left>
                        fas fa-exclamation-triangle
                    </v-icon>Delete Faq: {{ name }}
                </v-card-title>
                <v-card-text>
                    <p>Deleting this faq is permanent and cannot be undone.</p>
                    <p>Click "DELETE FAQ" to proceed.</p>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="toggleDeleteModal(false)"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="destroy()"
                    >
                        Delete Faq
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import FaqEditForm from './FaqEditForm';
import Overlay from '../../../../components/Overlay';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    components: { Overlay, FaqEditForm },


    computed: {
        ...mapState('faqEditor', ['deleteModal', 'name']),
    },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'faqEditor/toggleDeleteModal'
        }),

        ...mapActions({
            showNotification: 'notification/show',
            getData: 'faqEditor/getData',
            saveData: 'faqEditor/saveData',
            destroyData: 'faqEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
